// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 120px 100px;\n  gap: 24px;\n  align-items: flex-end;\n}\n.input-wrapper .menu {\n  z-index: 10;\n}\n", ""]);
// Exports
module.exports = exports;
